export const canPrepareBot = (bot) => {
  return bot?.status === 'draft'
    && bot?.lifecycle_capabilities?.can_prepare === true;
};
